import * as actionTypes from '../actions/ActionTypes';
import Config from '../../utils/Configuration';

function initState() {
    if (sessionStorage.getItem(Config.sliceKey.headerfooter)) {
        return {...JSON.parse(sessionStorage.getItem(Config.sliceKey.headerfooter))};
    }
    return {};
}
const initialState = initState();
const setHeaderFooterDetails = (state, payload) => {
    const updateState = {
        ...state,
        ...payload
    };
    sessionStorage.setItem(Config.sliceKey.headerfooter, JSON.stringify(updateState));
    return updateState;
};

const reducer = (state = initialState, action) => {
    const {payload} = action;
    switch (action.type) {
        case actionTypes.GET_HEADER_FOOTER:
            return setHeaderFooterDetails(state, payload);
        default:
            return state;
    }
};

export default reducer;
